import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";

/** @jsx $jsx */
import { $jsx } from 'framework7';
import moment from 'moment';
import AutoNumeric from 'autonumeric';
import Base from '../js/base';
import Utils from '../js/utils';
export default (function ($props, _ref) {
  var $on = _ref.$on,
      $ = _ref.$,
      $f7 = _ref.$f7,
      $update = _ref.$update,
      $tick = _ref.$tick;
  var pn_name = 'report-huyhieu';
  var pn = "div[data-name=\"".concat(pn_name, "\"]");
  var route = 'ReportHuyhieu';
  var lastmonth = moment().subtract(1, 'months').format('YYYY-MM');
  var $tableCanhan, $tableGroup; //Tổng tất cả điểm trao tặng

  var grandTotalPoint = 0,
      perPoint = 0,
      totalAmount = 0;
  /**
   * Xem báo cáo
  */

  var viewReport = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(e) {
      var data;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              data = $f7.form.convertToData($(pn + ' .huyhieu-report-form'));

              if (!(data.month.length != 7)) {
                _context.next = 4;
                break;
              }

              $f7.dialog.alert('Tháng sai định dạng YYYY-MM. VD: 2022-02');
              return _context.abrupt("return", false);

            case 4:
              getReport(data);

            case 5:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function viewReport(_x) {
      return _ref2.apply(this, arguments);
    };
  }();
  /**
   * Lưu thông tin quy đổi 
   */


  var saveTongtien = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(e) {
      var data, loader;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              data = $f7.form.convertToData($(pn + ' .huyhieu-report-form'));

              if (!(data.month.length != 7)) {
                _context2.next = 4;
                break;
              }

              $f7.dialog.alert('Tháng sai định dạng YYYY-MM. VD: 2022-02');
              return _context2.abrupt("return", false);

            case 4:
              if (!(grandTotalPoint === 0)) {
                _context2.next = 7;
                break;
              }

              $f7.dialog.alert('Không có điểm quy đổi');
              return _context2.abrupt("return", false);

            case 7:
              totalAmount = Utils.str2Num(data.amount_input);
              data.amount = totalAmount;

              if (!(data.amount === 0)) {
                _context2.next = 12;
                break;
              }

              $f7.dialog.alert('Số tiền không hợp lệ');
              return _context2.abrupt("return", false);

            case 12:
              loader = $f7.dialog.preloader();
              _context2.next = 15;
              return Base.api('Emp_Huyhieu', 'saveHuyhieuExchanged', data);

            case 15:
              loader.close();
              $(pn + ' .huyhieu-report-form input[name="amount-input"]').val('');
              quydoiChitiet();

            case 18:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function saveTongtien(_x2) {
      return _ref3.apply(this, arguments);
    };
  }();
  /**
   * Hiển thị bảng quy đổi chi tiết 
   * 
  */


  var quydoiChitiet = function quydoiChitiet() {
    if (grandTotalPoint === 0 || totalAmount === 0) return;
    perPoint = Math.ceil(totalAmount / grandTotalPoint);
    $update();
    $tableCanhan.find('tr').each(function () {
      var $tr = $(this);
      if ($tr.find('td.point').length === 0) return;
      var point = Utils.str2Num($tr.find('td.point').text());
      var amount = Math.ceil(point * perPoint);
      $tr.find('td.amount').text(Utils.num2Str(amount));
    });
  };

  var getReport = /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(params) {
      var loading, rs, groupedCanhan, _loop, key;

      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              $tableCanhan.html('');
              grandTotalPoint = 0, perPoint = 0;
              totalAmount = 0;
              loading = $f7.dialog.preloader();
              _context3.next = 6;
              return Base.api('ReportHuyhieu', 'get', params);

            case 6:
              rs = _context3.sent;
              loading.close();
              groupedCanhan = {};
              rs.canhan.forEach(function (row) {
                var key = row.name + '-' + row.id_user;
                if (groupedCanhan[key] === undefined) groupedCanhan[key] = [row];else groupedCanhan[key].push(row);
              });

              _loop = function _loop(key) {
                var rows = groupedCanhan[key];
                var row = rows[0];
                var user = Base.initdata.employees.find(function (emp) {
                  return emp.id === row.id_user;
                });
                var totalPoint = 0; // const huyhieuRows = rows.map(item=>{
                // const huyhieu = AppData.huyhieus.find(hh=>hh.id === item.id_huyhieu);
                // totalPoint += parseInt(item.qty) * parseInt(huyhieu.point);
                // return `${item.qty}<span class="gray-smaller">x${huyhieu.point} điểm</span>`;
                // }).join(' + ');

                rows.map(function (item) {
                  return totalPoint += parseInt(item.qty);
                });
                var $row = $("\n        <tr>\n          <td>".concat(user.name, "</td>\n          <td class=\"numeric-cell point\">").concat(totalPoint, "</td>\n          <td class=\"numeric-cell amount\">-</td>\n        </tr> \n      "));
                grandTotalPoint += totalPoint;
                $tableCanhan.append($row);
              };

              for (key in groupedCanhan) {
                _loop(key);
              }

              $update();
              totalAmount = Utils.str2Num(rs.row_exchanged.amount);
              quydoiChitiet();

            case 15:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    return function getReport(_x3) {
      return _ref4.apply(this, arguments);
    };
  }();

  $on('pageAfterIn', function () {
    // //Init table
    $tableCanhan = $(pn + " .table-data-huyhieu-canhan tbody");
    getReport({
      month: lastmonth
    });
  });
  $on('page:init', function () {
    AutoNumeric.multiple(pn + ' .autonumeric', Base.autoNumericConfig);
  });
  return function ($ctx) {
      var $ = $ctx.$;
      var $h = $ctx.$h;
      var $root = $ctx.$root;
      var $f7 = $ctx.$f7;
      var $f7route = $ctx.$f7route;
      var $f7router = $ctx.$f7router;
      var $theme = $ctx.$theme;
      var $update = $ctx.$update;
      var $store = $ctx.$store;

      return $h`
<div class="page" data-name="${pn_name}">
  <div class="navbar">
    <div class="navbar-bg"></div>
    <div class="navbar-inner">
      <div class="left"><a href="#" data-panel=".panel-left" class="panel-open" id="menu-bars"><i class="f7-icons icon">bars</i></a></div>
      <div class="title sliding">Danh sách khen thưởng</div>
      <div class="right"></div>
    </div>
  </div>
  <div class="page-content">

        <div class="card data-table">
          <div class="card-header">
            <div>Thông tin quy đổi</div>
          </div>
          <div class="card-content">
            <div class="list huyhieu-report-form">
              <ul>
                <li class="item-content item-input">
                  <div class="item-inner">
                    <div class="item-title item-label">Tháng (YYYY-MM)</div>
                    <div class="item-input-wrap">
                      <input type="text" name="month" value="${lastmonth}" placeholder="YYYY-MM" />
                    </div>
                  </div>
                </li>
                <li class="item-content item-input">
                  <div class="item-inner">
                    <div class="item-title item-label">Tổng tiền đã giải ngân</div>
                    <div class="item-input-wrap">
                      <input type="text" name="amount" class="autonumeric" readonly value="${Utils.num2Str(totalAmount)}" />
                    </div>
                  </div>
                  <div class="item-inner">
                    <div class="item-title item-label">Số tiền</div>
                    <div class="item-input-wrap">
                      <input type="text" name="amount_input" class="autonumeric" />
                    </div>
                  </div>
                </li>
                <li class="item-content item-input">
                  <div class="item-inner">
                    <div class="item-title item-label">Tổng điểm</div>
                    <div class="item-input-wrap">
                      <input type="text" name="total_diem" value="${grandTotalPoint}" readonly />
                    </div>
                  </div>
                </li>
                <li class="item-content item-input">
                  <div class="item-inner">
                    <div class="item-title item-label">Mỗi điểm</div>
                    <div class="item-input-wrap">
                      <input type="text" name="moi_diem" value="${Utils.num2Str(perPoint)}" readonly />
                    </div>
                  </div>
                </li>
                <li class="item-content item-input">
                  <div class="item-inner">
                      <a class="button margin-right" @click="${viewReport}">XEM</a>
                  </div>
                  <div class="item-inner">
                    <a class="button margin-left" @click="${saveTongtien}">QUY ĐỔI & LƯU LẠI</a>
                </div>
                </li>
              </ul>
            </div>
          </div>
        </div>


        <div class="card data-table">
          <div class="card-header">
            <div>Danh sách khen thưởng</div>
          </div>
          <div class="card-content">
            <table class="table-data-huyhieu-canhan">
              <thead>
                <tr>
                  <th>Tên nhân viên</th>
                  <th class="numeric-cell">Tổng điểm</th>
                  <th class="numeric-cell">Quy đổi</th>
                </tr>
              </thead>
              <tbody>
                
              </tbody>
            </table>
          </div>
        </div>

  </div>
</div>
`
    }
    ;
});